import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from 'src/app/base/base.component';
import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { Config } from 'src/infrastructure/config';
import { PaymentMethod } from 'src/infrastructure/enums/paymentMethod';
import { ShipmentType } from 'src/infrastructure/enums/shipmentType';
import { Card } from 'src/models/DTO/card/Card';
import { CartLine } from 'src/models/DTO/cart/cartLine';
import { WholeCart } from 'src/models/DTO/cart/wholeCart';
import { PlainContactV2 } from 'src/models/DTO/contact/plainContactV2';
import { Item } from 'src/models/DTO/items/item';
import { OrderInfo } from 'src/models/DTO/orders/orderInfo';
import { PaymentMethods } from 'src/models/DTO/payMethods/paymentMethods';
import { UserDTO } from 'src/models/DTO/user/user';
import { Voucher } from 'src/models/DTO/vouchers/voucher';
import { VoucherItem } from 'src/models/DTO/vouchers/voucherItem';
import { CreateGroupOrderRequestModel } from 'src/models/requestModels/groups/CreateGroupOrderRequestModel';
import { CreateOrderRequestModel } from 'src/models/requestModels/orders/CreateOrderRequestModel';
import { ToastService } from 'src/services/core/toast/toast.service';
import { UserService } from 'src/services/core/user/user.service';
import { CartService } from 'src/services/request/cart/cart.service';
import { GroupsService } from 'src/services/request/groups/groups.service';
import { ImagesService } from 'src/services/request/images/images.service';
import { OrderService } from 'src/services/request/orders/order.service';
import { PayMethodsService } from 'src/services/request/pay-methods/pay-methods.service';
import { ProductService } from 'src/services/request/product/product.service';
import { UserInfoService } from 'src/services/request/user/userinfo.service';
import { VouchersService } from 'src/services/request/vouchers/vouchers.service';
import { GroupStateService } from 'src/services/state/group/group-state.service';
import { HistoryService } from 'src/services/state/history/history.service';
import { LoggedUserService } from 'src/services/state/loggeduser/loggeduser.service';
import { OrederStateService } from 'src/services/state/order/oreder-state.service';

declare var Stripe: any;

@Component({
  selector: 'app-currentorder',
  templateUrl: './currentorder.component.html',
  styleUrls: ['./currentorder.component.css']
})
export class CurrentorderComponent extends HistoryBaseComponent implements OnInit {

  private _odredInfo?: OrderInfo;
  private _cartLinePerOrganisation:  {[key : string]: CartLine[]} = {};
  private _cartTotalPerOrganisation:  {[key : string]: number} = {};
  private _cartSelectedPerOrganisation:  {[key : string]: boolean} = {};
  private _cartLines:  {[key : string]: CartLine} = {};
  private _cart?: WholeCart;
  private _paymentMethods?: PaymentMethods;
  private _order?: OrderInfo;
  private _loggedUser?: UserDTO;
  private _vouchers: Voucher = { data: [] };
  private _selectedVoucher? : VoucherItem;
  private _groupRequestModel?: CreateGroupOrderRequestModel;
  private _groupItem? : Item;
  private _groupCartLine?:  CartLine;
  private _isGroup: boolean = false;
  private _payBtnDisabled = false;
  public paymentErrorMessage = '';
  private _stripe: any;

  constructor(
    private orderStateService: OrederStateService,
    private userService: UserInfoService,
    private voucherService: VouchersService,
    private imageService: ImagesService,
    private orderService: OrderService,
    private paymentMethodService: PayMethodsService,
    private loggedUserService: LoggedUserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private groupStateService: GroupStateService,
    private groupService: GroupsService,
    private productService: ProductService,
    private modalService: NgbModal,
    private toastService: ToastService,
    protected location: Location,
    protected historyService: HistoryService
  ) {
    super(location, historyService);
    this.loggedUserService.userInfo$.subscribe((user) => {
      this._loggedUser = user;
    });
    this.loadVouchers();
    this.paymentMethodService.getPaymentMethods().subscribe(paymentsMethods => this._paymentMethods = paymentsMethods);
    this._stripe = Stripe(Config.stripeKey);
  }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      if (params.group) {
        this._isGroup = true;
        this.groupStateService.orderInfo$.subscribe(group => {
          if (group && Object.keys(group).length) {
            this._groupRequestModel = group
            let sku = group.product?.data.skus.find(sku => sku.uuid == group.sku.uuid)
            this._groupCartLine = {
              uuid: '',
              sku: {
                uuid: sku?.uuid!,
                sku: sku?.sku!,
                available_quantity: sku?.available_quantity.toString() || '0',
                options: sku?.options!,
                product: group.product?.data!
              },
              quantity: group.sku.quantity,
              total_amount: group.sum!,
              price_per_piece: (Number.parseFloat(group.sum!) / group.sku.quantity).toFixed(2)
            }
            if (sku) {
              this.loadGroupImages();
            }
            if (this._groupRequestModel.group_uuid) {
              this._groupCartLine.total_amount = (Number.parseFloat(group.sum!) * sku!.available_quantity).toFixed(2);
            }
          }
        })
      }
      this.orderStateService.orderInfo$.subscribe((order) => {
        this._order = order;
        if (order && !this._isGroup) {
          this.loadCart();
        }
      })
    })
  }

  get payBtnDisabled() {
    return this._payBtnDisabled;
  }

  get isGroup() {
    return this._isGroup;
  }

  get groupCartLine() {
    return this._groupCartLine;
  }

  get groupModel() {
    return this._groupRequestModel;
  }

  get userVouchers() : Voucher {
    return this._vouchers;
  }

  get orderInfo() {
    return this._odredInfo;
  }

  get deliveryAddress() {
    return this.orderInfo?.city + ', ' + this.orderInfo?.country + ', ' + (this.orderInfo?.address || '')
  }

  get invoiceAddress() {
    return this.orderInfo?.invoiceCity + ', ' + this.orderInfo?.invoiceCounty + ', ' + (this.orderInfo?.invoiceAddress || '')
  }


  get cartLinePerOrganisation() {
    return this._cartLinePerOrganisation;
  }

  get cartTotalPerOrganisation() {
    return this._cartTotalPerOrganisation;
  }

  get cartSelectedPerOrganisation() {
    return this._cartSelectedPerOrganisation;
  }

  get cartLines() {
    return this._cartLines;
  }

  get allOrgs() {
    return Object.keys(this._cartTotalPerOrganisation);
  }

  get cart() {
    return this._cart;
  }

  get numberOfCartLines() {
    return this.cart?.lines.length || 0;
  }

  get order() {
    return this._order;
  }

  get cartAmount() {
    if (!this.cart?.amount) {
      return 0.00;
    }
    return Number.parseFloat(this.cart?.amount)
  }

  get deliveryAmount() {
    let allDelivery = 0;
    Object.keys(this._cartLinePerOrganisation).forEach(key => {
      allDelivery += this.deliveryForCartLine(this._cartLinePerOrganisation[key], this._cartTotalPerOrganisation[key]);
    })
    return allDelivery;
  }

  get groupDelivery() {
    let delivery = 0;
    if (this._groupCartLine) {
      delivery = this.deliveryForCartLine([this._groupCartLine!], Number.parseFloat(this.groupSum))
    }
    return delivery;
  }

  get groupDeliveryAmountAsString() {
    return this.groupDelivery.toFixed(2);
  }

  get deliveryAmountAsString() {
    return this.deliveryAmount.toFixed(2);
  }

  get productsSum() {
    return this.cartAmount.toFixed(2)
  }

  get groupSum() {
    return this._groupRequestModel?.sum || '0.00';
  }

  get groupWholeSum() {
    return this.calculateGroupWholeSum()
  }

  get wholeSum() {
    let voucherAmount = Number.parseFloat(this._selectedVoucher?.amount || '0');
    const sum = this.cartAmount + this.deliveryAmount - voucherAmount;
    if (sum < 0) {
      return Number(0).toFixed(2)
    }
    return (this.cartAmount + this.deliveryAmount - voucherAmount).toFixed(2)
  }

  get selectedVoucher() {
    return this._selectedVoucher;
  }

  get groupBtn() {
    if (this._isGroup) {
      if (this._groupRequestModel?.group_uuid) {
        return 'Присъедини се и поръчай'
      }
      return "Създай група и поръчай"
    }
    return ''
  }

  private loadVouchers() {
    this.voucherService.getVouchersForUser().subscribe(vouchers => {
      this._vouchers = vouchers;
    })
  }

  private loadGroupImages() {
      this.imageService.getImagesForProduct("SKU", this._groupRequestModel!.sku.uuid).subscribe(image => {
        if (image.data.length) {
          this._groupRequestModel!.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
          this._groupCartLine!.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
        }
        else {
          this.imageService.getImagesForProduct("PRODUCT", this._groupRequestModel!.product!.data.uuid).subscribe(image => {
            this._groupRequestModel!.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
            this._groupCartLine!.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
          })
        }
      })
  }

  private async loadCart(){
    if (this._cart) return;
    this._cart = (await this.userService.loadUser().toPromise()).data.cart;
    this._cart!.lines.forEach(line => {
      this._cartLines[line.uuid] = line;
      this.imageService.getImagesForProduct("SKU", line.sku.uuid).subscribe(image => {
        if (image.data.length) {
          line.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
        }
        else {
          this.imageService.getImagesForProduct("PRODUCT", line.sku.product.uuid).subscribe(image => {
            line.imageSource = image.data[0]?.original.url || '/assets/images/shared/logo.png';
          })
        }
      })
        this._odredInfo = this._order;
    })
    this.filterCartLines();
  }

  private filterCartLines() {
    this._cart!.lines.forEach(line => {
      let totalSumForLine = line.quantity * Number.parseFloat(this.getPriceForCartLinePerAmount(line));
      if (this._cartLinePerOrganisation[line.sku.product.organisation.uuid]) {
        this._cartLinePerOrganisation[line.sku.product.organisation.uuid].push(line);
        this._cartTotalPerOrganisation[line.sku.product.organisation.uuid] += Number.parseFloat(totalSumForLine.toFixed(2));
      }
      else {
        this._cartLinePerOrganisation[line.sku.product.organisation.uuid] = [line];
        this._cartTotalPerOrganisation[line.sku.product.organisation.uuid] = Number.parseFloat(totalSumForLine.toFixed(2));
      }
    })
  }

  public calculateGroupWholeSum() {
    let voucherAmount = Number.parseFloat(this._selectedVoucher?.amount || '0');
    const sum = Number.parseFloat(this._groupRequestModel?.sum || '0.0') + this.groupDelivery - voucherAmount;
    if (sum < 0) {
      return Number(0).toFixed(2)
    }
    return sum.toFixed(2)
  }

  isProductAvailable(productPerOrg: CartLine) {
    return !productPerOrg.sku.product.deleted_at && productPerOrg.sku.product.state == Config.activeState;
  }

  clearVoucher() {
    this._vouchers.data.push(this._selectedVoucher!);
    this._selectedVoucher = undefined;

  }

  private createGroup(orderToCreate: CreateOrderRequestModel) {
    this.paymentErrorMessage = '';
    if (!this._groupRequestModel?.group_uuid) {
      this._groupRequestModel!.create_group = true;
    }
    else {
      delete this._groupRequestModel?.create_group;
    }
    this._groupRequestModel!.payment = orderToCreate.payment;
    this._groupRequestModel!.shipping = orderToCreate.shipping;
    this.groupService.createGroup(this._groupRequestModel!).subscribe((groupCreated) => {
      if(groupCreated.data.payment.providerPaymentStatus == Config.stripeStatuses.invalidPaymentStatus) {
        this.displayStripeErrorAndStayOnCheckout(groupCreated?.data?.payment?.lastPaymentError);
        return;
      }
      if(groupCreated.data.payment.providerPaymentStatus == Config.stripeStatuses.confirmationPaymentRequiredStatus) {
        this._stripe.handleNextAction(
          {clientSecret: groupCreated.data.payment.clientSecret}
        ).then((result: any) => {
          if (result.error) {
            this.handlePaymentFailureAndStayOnCheckout(
              result.error,
              groupCreated?.data?.payment?.providerChargeId
            );
            return;
          }
          else {
            this.navigateToSuccessfullGroup(groupCreated)
          }
        })
      }
      else {
        this.navigateToSuccessfullGroup(groupCreated)
      }
     },
    (error) => this.displayStripeErrorAndStayOnCheckout(error));
  }

  pay() {
    this._payBtnDisabled = true;
    this.paymentErrorMessage = '';
    let paymentMethod = this._paymentMethods!.data.find(payMethod => payMethod.code == PaymentMethod.COD)?.uuid;
    if (this._order?.paymentCard && this._order?.cardPayment) {
      paymentMethod = this._paymentMethods!.data.find(payMethod => payMethod.code == PaymentMethod.CARD)?.uuid;
    }

    let shipmentType = ShipmentType.types.toDoor;
    if (this._order?.carrierOfficeAddress && this._order?.toCarrierOffice) {
      shipmentType =ShipmentType.types.toOffice
    }

    const orderToCreate: CreateOrderRequestModel = {
      cart_uuid: this._order?.cart?.uuid || null,
      payment: {
        payment_method: (!this._order?.cashPayment) ? this._order?.paymentCard!.id : null,
        method_uuid: paymentMethod || null,
        user_stored_method_id: null,
        invoice_contact_uuid: !this._order!.isNewInvoiceAddress ? this._order?.contactUUID?.toString() : this._order!.invoiceContactUUID,
        invoice_contact_same_as_shipping: this._order!.sameAddressForInvoice || false,
        setup_user_method_for_future_usage: true
      },
      shipping: {
        method: shipmentType,
        carrier_office_id: shipmentType == ShipmentType.types.toOffice ? this._order?.carrierOfficeId?.toString() : null,
        contact_uuid: this._order?.contactUUID?.toString(),
        carrier_uuid: Config.SPEEDY_CARRIER
      }
    }
    if (this._selectedVoucher) {
      orderToCreate.voucher_uuid = this._selectedVoucher.uuid;
    }
    if (this._isGroup) {
      this.createGroup(orderToCreate);
    }
    else {
      this.orderService.createOrder(orderToCreate).subscribe((response) => {
        if(response.data.payment.providerPaymentStatus == Config.stripeStatuses.invalidPaymentStatus) {
          this.displayStripeErrorAndStayOnCheckout(response?.data?.payment?.lastPaymentError);
          return;
        }
        if(response.data.payment.providerPaymentStatus == Config.stripeStatuses.confirmationPaymentRequiredStatus) {
          this._stripe.handleNextAction(
            {clientSecret: response.data.payment.clientSecret}
          ).then((result: any) => {
            if (result.error) {
              this.handlePaymentFailureAndStayOnCheckout(
                result.error,
                response?.data?.payment?.providerChargeId
              );
              return;
            }
            else {
              this.navigateToSuccessfullOrder(response)
            }
          })
        }
        else {
          this.navigateToSuccessfullOrder(response)
        }
      },
      (error) => this.displayStripeErrorAndStayOnCheckout(error))
    }
  }

  private handlePaymentFailureAndStayOnCheckout(error?: any, paymentIntentId?: string): void {
    if (!paymentIntentId) {
      this.displayStripeErrorAndStayOnCheckout(error);
      return;
    }
    this.orderService.cleanupFailedPayment(paymentIntentId).subscribe(
      () => this.displayStripeErrorAndStayOnCheckout(error),
      () => this.displayStripeErrorAndStayOnCheckout(error)
    );
  }

  public displayStripeErrorAndStayOnCheckout(error?: any): void {
    const message = this.getPaymentErrorMessage(error);

    this._payBtnDisabled = false;
    this.paymentErrorMessage = message;
    this.toastService.error(message);
  }

  private getPaymentErrorMessage(error?: any): string {
    const code = this.getPaymentErrorCode(error);

    if (code === 'insufficient_funds') {
      return 'Картата няма достатъчна наличност. Моля, изберете друга карта или опитайте отново.';
    }

    if (code === 'card_declined') {
      return 'Плащането с картата беше отказано. Моля, изберете друга карта или опитайте отново.';
    }

    if (code === 'authentication_failed') {
      return '3D верификацията беше неуспешна. Моля, опитайте отново.';
    }

    if (code === 'expired_card') {
      return 'Картата е с изтекъл срок. Моля, изберете друга карта.';
    }

    if (code === 'incorrect_cvc') {
      return 'CVC кодът на картата е невалиден. Моля, проверете данните и опитайте отново.';
    }

    const productAvailabilityReason = error?.error?.data?.reason;
    if (
      error?.status === 400
      && ['insufficient_quantity', 'product_unavailable'].includes(productAvailabilityReason)
    ) {
      const apiMessage = error?.error?.message;
      if (apiMessage) {
        return apiMessage;
      }

      const productName = error?.error?.data?.product_name || 'Избраният продукт';
      const sku = error?.error?.data?.sku ? ` (SKU: ${error.error.data.sku})` : '';

      return `Продуктът „${productName}“${sku} вече не е наличен в желаното количество. Моля, върнете се към количката и актуализирайте количеството.`;
    }

    if (error?.status === 402 || error?.error?.status_code === 402) {
      return 'Плащането е неуспешно. Моля, изберете друга карта или опитайте отново.';
    }

    if (error?.status === 422 || error?.error?.errors?.cart_uuid) {
      return 'Количката вече не е активна. Моля, върнете се към количката и опитайте отново.';
    }

    return 'Плащането е неуспешно. Моля, изберете друга карта или опитайте отново.';
  }

  private getPaymentErrorCode(error?: any): string {
    return error?.decline_code
      || error?.code
      || error?.error?.decline_code
      || error?.error?.code
      || error?.data?.payment?.lastPaymentError?.decline_code
      || error?.data?.payment?.lastPaymentError?.code
      || error?.error?.data?.payment?.lastPaymentError?.decline_code
      || error?.error?.data?.payment?.lastPaymentError?.code
      || '';
  }

  public navigateToSuccessfullGroup(groupCreated: any) {
      let isJoined = this._groupRequestModel?.group_uuid ? true : false;
      this.groupStateService.removeOrderInfo();
      this._payBtnDisabled = false;
      if (!isJoined) {
        this.router.navigate(['/order/complete/group/' + groupCreated.data.group_uuid])
      }
      else {
        this.router.navigate(['/group/completed/' + groupCreated.data.group_uuid])
      }
  }


  public navigateToSuccessfullOrder(responseFromCreatedOrder: any) {
    this.userService.loadUser().subscribe((user) => {
      delete user.data.cart;
      this.loggedUserService.addNewUser(user);
      this.groupStateService.removeOrderInfo();
      this._payBtnDisabled = false;
      this.router.navigate(['/order/complete/' + responseFromCreatedOrder.data.orders[0].display_id])
    })
  }

  public deliveryForCartLine(cartLines: CartLine[], total: number) {
    if (Number.parseFloat(cartLines[0].sku.product.organisation.free_delivery_after_order_amount) < total) {
      let freeDelivery = 0;
      return freeDelivery;
    }
    const delyveryTax = this._order!.toAddress ? cartLines[0].sku.product.organisation.delivery_to_address_price : cartLines[0].sku.product.organisation.delivery_to_courier_office_price;
    return Number.parseFloat(delyveryTax);
  }

  public deliveryForCartLineAsString(cartLines: CartLine[], total: number) {
    return this.deliveryForCartLine(cartLines, total).toFixed(2)
  }

  public cardImg(card: Card) {
    let cardImage = '/assets/images/cards/card-mastercard.svg';
    if (card.card.brand == "visa") {
      cardImage = '/assets/images/cards/card-visa.svg';
    }
    return cardImage
  }

  public getCardDetail(card: Card) {
    let cardName = "MASTERCARD *";
    if (card.card.brand == "visa") {
      cardName = "VISA DEBIT *";
    }
    return cardName + card.card.last4
  }

  public fixVoucherSum(voucherSum: string) {
    return Number.parseFloat(voucherSum).toFixed(2) + " лв."
  }

  public fixVoucherDate(voucherDate: string) {
    const fixedDate = new Date(voucherDate).toLocaleDateString();
    return "Получен на: " + fixedDate;
  }

  chooseVoucher(voucher: VoucherItem, modal: any) {
    this._selectedVoucher = voucher;
    this._vouchers.data = this._vouchers.data.filter(availableVoucher => availableVoucher.uuid !=  voucher.uuid);
    modal.close();
  }

  public open(modal: any) {
    this.modalService.open(modal, { size: 'sm',  windowClass: 'loginModal' })
  }

  getAddressString() {
    // return address.city + ', ' + address.post_code + ', ' + address.country?.name
    return this.order?.address;
  }

  getInvoiceAddressString() {
    // return address.city + ', ' + address.post_code + ', ' + address.country?.name
    return this.order?.invoiceAddress;
  }

  getNameAsString() {
    return this._loggedUser?.data.fist_name + ' ' + this._loggedUser?.data.last_name;
  }

  getTelAsString(address: PlainContactV2) {
    return address.mobile_phone_1_e164;
  }

  pricingInfo(cartLine: CartLine) {
    let price = this.getPriceForCartLinePerAmount(cartLine);
    let priceAsString =  Number.parseFloat(price).toFixed(2);
    return  cartLine.quantity + ' x ' + priceAsString + ' лв.';
  }

  goToProduct(productPerOrg: CartLine) {
    this.router.navigate(['product/' + productPerOrg.sku.product.uuid + '/' + 'none'])
  }



  getPriceAsFixedString(cartLine: CartLine) {
    if (!cartLine.price_per_piece) return '00.00';
    let price = this.getPriceForCartLinePerAmount(cartLine);
    let priceCalculated =  Number.parseFloat(price) * cartLine.quantity
    let fixedPrice = priceCalculated.toFixed(2);
    let priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return priceArray;
  }

  getTotalPriceAsFixedString(price: string) {
    if (!price) return '00.00';
    let fixedPrice = Number.parseFloat(price).toFixed(2);
    let priceArray = fixedPrice.split('.');
    priceArray[0] = priceArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return priceArray[0] + '.' +priceArray[1];
  }

  getUnitPriceBase(cartLine: CartLine): number {
    const raw = this.getPriceForCartLinePerAmount(cartLine);
    return Number(raw) || 0;
  }

  getLineTotalBase(cartLine: CartLine): number {
    return this.getUnitPriceBase(cartLine) * (Number(cartLine.quantity) || 0);
  }

  pricingInfoText(cartLine: CartLine): string {
    return `${Number(cartLine.quantity) || 0} x`;
  }

  getOrgDeliveryBase(orgKey: string): number {
    const lines = this._cartLinePerOrganisation?.[orgKey] || [];
    const total = this._cartTotalPerOrganisation?.[orgKey] || 0;
    return Number(this.deliveryForCartLine(lines, total)) || 0;
  }

  getOrgGrandTotalBase(orgKey: string): number {
    const subtotal = Number(this._cartTotalPerOrganisation?.[orgKey]) || 0;
    return subtotal + this.getOrgDeliveryBase(orgKey);
  }

  getProductsSubtotalBase(): number {
    return Number(this.productsSum) || 0;
  }

  getDeliveryAmountBase(): number {
    return Number(this.deliveryAmount) || 0;
  }

  getSelectedVoucherBase(): number {
    return Number(this._selectedVoucher?.amount) || 0;
  }

  getWholeSumBase(): number {
    return Number(this.wholeSum) || 0;
  }

  getGroupSubtotalBase(): number {
    return Number(this.groupSum) || 0;
  }

  getGroupDeliveryBase(): number {
    return Number(this.groupDelivery) || 0;
  }

  getGroupGrandTotalBase(): number {
    return Number(this.groupWholeSum) || 0;
  }

  private getPriceForCartLinePerAmount(cartLine: CartLine) {
    let pricing = cartLine.sku.product.pricing.sort((pricingA, pricingB) => pricingA.quantity_from - pricingB.quantity_from)
    let priceToReturn = pricing[pricing.length - 1].price_per_piece;
    let productUUID = cartLine.sku.product.uuid;
    let quantity = 0;
    this.cart?.lines.forEach(line => {
      if (line.sku.product.uuid == productUUID) {
        quantity += line.quantity;
      }
    })
    if (!quantity) quantity = Number.parseInt(cartLine.quantity.toString());
    if (this._groupRequestModel?.group_uuid) {
      quantity = this._groupRequestModel.quantity!;
    }
    for (const price of pricing) {
      if (price.quantity_from <= quantity && price.quantity_to >= quantity) {
        priceToReturn = price.price_per_piece;
      }
    }
    return priceToReturn;
  }

  returnOptionValue(option: any) {
    if (option.option.values.length) {
      let optionSelected = option.option.values.find((value: { uuid: any; }) => value.uuid == option.value);
      return optionSelected.value;
    }
    return option.value;
  }
  getVoucherAmountBase(voucher: any): number {
    return Number(voucher?.amount) || 0;
  }

}
